import { fetchFeatureFlagsAction } from './actions';

const initialState = {
  isFetching: false,
  flags: {},
  toggles: [],
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchFeatureFlagsAction.pending.toString(): {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }
    case fetchFeatureFlagsAction.fulfilled.toString(): {
      const { toggles = [] } = action.payload || {};
      const flags = toggles.reduce((acc, toggle) => {
        acc[toggle.name] = toggle.enabled;
        return acc;
      }, {});

      return {
        ...state,
        isFetching: false,
        flags,
        toggles
      };
    }
    case fetchFeatureFlagsAction.rejected.toString(): {
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
